<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import { organizationModule } from '@/store/organization/module'

const {
    Button: PocketButton,
    Input: PocketInput,
    Icon,
} = UIKit

const props = withDefaults(
    defineProps<{
        isLoading?: boolean
    }>(),
    { isLoading: false }
)

const emit = defineEmits<{
    submitNameYourOrg: [payload: { orgName: string }]
}>()

const orgName = ref('')

const currentOrganization = computed(() => {
    return organizationModule.getters.getCurrentOrganization()
})

const submitNameYourOrg = () => {
    const payload = {
        orgName: orgName.value,
    }

    emit('submitNameYourOrg', payload)

    return payload
}

onMounted(async () => {
    await Promise.all([
        organizationModule.actions.fetchCurrentOrganization(),
    ])

    if (currentOrganization.value) {
        orgName.value = currentOrganization.value.name
    }
})
</script>

<template>
    <div class="name-org">
        <img
            class="name-org__blob-left"
            src="@/assets/images/create-name-blob-topleft.svg"
        >
        <img
            class="name-org__blob-right"
            src="@/assets/images/create-name-blob-right.svg"
        >
        <img
            class="name-org__pom-pom"
            src="@/assets/images/create-name-pom-pom.png"
        >
        <img
            class="name-org__finger"
            src="@/assets/images/create-name-finger.png"
        >
        <div class="name-org__step-text">
            Step 2 of 3
        </div>
        <div class="name-org__text-big">
            What is the name of your organization?
        </div>
        <div class="name-org__text-small">
            This is the name students and colleagues will see when you invite them to join you.
        </div>
        <PocketInput
            v-model="orgName"
            class="name-org__text-input"
            type="text"
            label="Organization Name"
            placeholder="i.e. School, Company, Department"
        />
        <div class="name-org__text-dont-sweat">
            Don't sweat this one, <br> you can change it later
        </div>
        <PocketButton
            class="name-org__submit"
            :disabled="!orgName || props.isLoading"
            @click="submitNameYourOrg"
        >
            Choose Exam <Icon class="name-org__submit-arrow" type="arrow" />
        </PocketButton>
    </div>
</template>

<style lang="scss" scoped>


.name-org {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 26px;

    &__blob-left {
        position: absolute;
        top: 0;
        left: 0;
    }

    &__blob-right {
        position: absolute;
        right: 0;
        bottom: 40px;
    }

    &__pom-pom {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 164px;
        height: 364px;
    }

    &__finger {
        position: absolute;
        right: 78px;
        bottom: -1px;
        width: 176px;
        height: 299px;
    }

    &__step-text {
        color: $slate-03;
        font-size: 13px;
        line-height: 17.76px;
        margin-bottom: 10px;
    }

    &__text-big {
        font-size: 26px;
        line-height: 35.52px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    &__text-small {
        width: 303px;
        font-size: 14px;
        line-height: 19.12px;
        text-align: center;
        color: $slate-03;
        margin-bottom: 45px;
    }

    &__text-input {
        width: 320px;
        margin-bottom: 18px;
    }

    &__text-dont-sweat {
        width: 197px;
        font-size: 14px;
        line-height: 19.12px;
        text-align: center;
        color: $slate-03;
        margin-bottom: 34px;
    }

    &__submit {
        margin-bottom: 212px;
    }

    &__submit-arrow {
        margin-left: 5px;
    }
}
</style>
